module.exports = __webpack_public_path__ + "static/media/uganda_map.b6415138.png";